export enum CourseOrderPaymentType {
  singleDeduction = 0,
  severalDeductions = 1,
}
